import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import axios from "axios";
// import { Configuration } from "../../apiClient";
import { useKeycloak } from "@react-keycloak/web";

interface ClientInquiry {
  id: string;
  carId: string;
  clientName: string;
  clientPhone: string;
  message: string;
  requestDate: string;
  status: 'NEW' | 'CALLED' | 'CLOSED';
}

const InquiryBoard = () => {
  const [inquiries, setInquiries] = useState<ClientInquiry[]>([]);
  const { keycloak } = useKeycloak();
  const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8080";

  useEffect(() => {
    const fetchInquiries = async () => {
      try {
        const response = await axios.get(`${baseURL}/inquiry`, {
            headers: {
                Authorization: `Bearer ${keycloak.token}`
            }
        });
        setInquiries(response.data);
      } catch (error) {
        console.error("Failed to fetch inquiries", error);
      }
    };
    fetchInquiries();
  }, [keycloak.token]);

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Solicitări Clienți
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nume</TableCell>
              <TableCell>Telefon</TableCell>
              <TableCell>Mesaj</TableCell>
              <TableCell>Data</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {inquiries.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.clientName}</TableCell>
                <TableCell>{row.clientPhone}</TableCell>
                <TableCell>{row.message}</TableCell>
                <TableCell>{new Date(row.requestDate).toLocaleDateString()}</TableCell>
                <TableCell>
                  <Chip 
                    label={row.status} 
                    color={row.status === 'NEW' ? "success" : "default"} 
                    size="small" 
                  />
                </TableCell>
              </TableRow>
            ))}
            {inquiries.length === 0 && (
                <TableRow>
                    <TableCell colSpan={5} align="center">Nu există solicitări.</TableCell>
                </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InquiryBoard;
